class FeaturedImageOrientation {
	constructor() {
		this.images = document.querySelectorAll(
			'.single-post__img img, .single-news__img img'
		);

		if (this.images.length === 0) return;

		this.init();
	}

	init() {
		this.images.forEach((img) => {
			if (img.complete && img.naturalWidth > 0) {
				this.applyOrientation(img);
			} else {
				img.addEventListener('load', () => this.applyOrientation(img), {
					once: true,
				});
			}
		});
	}

	applyOrientation(img) {
		const { naturalWidth: w, naturalHeight: h } = img;
		if (!w || !h) return;

		img.classList.toggle('is-horizontal', w >= h);
		img.classList.toggle('is-vertical', w < h);
	}

	static init() {
		new FeaturedImageOrientation();
	}
}

export default FeaturedImageOrientation;
